import { useEffect } from "react";

const BASE_URL = "https://conjureflow.app";

const setMeta = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export const useSeo = ({ title, description, path, jsonLd = [], noindex = false }) => {
  const jsonLdKey = JSON.stringify(jsonLd);

  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', description);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:image"]', `${BASE_URL}/og-image.png`);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[name="twitter:image"]', `${BASE_URL}/og-image.png`);
    document.head
      .querySelector('link[rel="canonical"]')
      ?.setAttribute("href", url);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");

    const scripts = jsonLd.map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.dataset.routeSeo = "true";
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => scripts.forEach((s) => s.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, jsonLdKey, noindex]);
};
